// extracted by mini-css-extract-plugin
export default {"tooltip":"styles_tooltip__9AeXo"};